// extracted by mini-css-extract-plugin
module.exports = {"label-chip":"LabelView_label-chip__knmZm","edit":"LabelView_edit__SAClx","edit-icon":"LabelView_edit-icon__381Zo","next-to-previous":"LabelView_next-to-previous__dQHoe"};